import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { ApiClient } from '@/services/api-client';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { CustomClassification } from '@/services/types/Lead.types';

const QUERY_KEY = ['organization.customClassifications'];

export function useCustomClassifications() {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: () => ApiClient.organization.getCustomClassifications(),
    staleTime: 60_000,
    select: (res) => res.data?.CustomClassifications ?? [],
  });
}

export function useCreateCustomClassification() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (req: { label: string; color: string; text_color: string }) =>
      ApiClient.organization.createCustomClassification(req),
    onSuccess: (res) => {
      queryClient.setQueryData(QUERY_KEY, res);
    },
  });
}

export function useDeleteCustomClassification() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (classificationId: string) =>
      ApiClient.organization.deleteCustomClassification(classificationId),
    onSuccess: (res) => {
      queryClient.setQueryData(QUERY_KEY, res);
      // Invalidate conversations since some leads may have moved to undetermined
      queryClient.invalidateQueries({ queryKey: ['lead.getConversations'] });
      queryClient.invalidateQueries({ queryKey: ['lead.getSearchIndex'] });
    },
  });
}
